import {configs} from 'configs';
import _ from 'lodash';

/**
 * Returns url to log out user
 *
 * @param {string} redirectUrl
 */
export function signOut(redirectUrl) {
  `${configs.keycloakUrl}/auth/realms/athlinks/` +
    `protocol/openid-connect/logout` +
    `?post_logout_redirect_uri=${encodeURIComponent(redirectUrl)}`;
}

export function isReferrerValid(referrerPath) {
  return referrerPath !== '/signin' && referrerPath !== '/signup';
}

export function isRedirectUrlValid(url) {
  return url.match(/\/signin/i) < 0 && url.match(/\/signup/i) < 0;
}

export function query() {
  const parsed = new URL(window.location.href);
  return `returnUrl=${encodeURIComponent(parsed.pathname)}`;
}

export function signUp () {
  return _.map(query, (value, key) => `${key}=${encodeURIComponent(value)}`)
    .join('&');
}



/** WEBPACK FOOTER **
 ** ./utils/auth.js
 **/